import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appOutside]',
   host: {
   '(document:click)': 'onClick($event)',
  }
})
export class EventListenerDirective {
  @Output()
  appOutsideClick = new EventEmitter();

  constructor(private elementRef: ElementRef) { 

  }

  onClick(targetElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement.target);
    if (!clickedInside) {
      this.appOutsideClick.emit(true);
    } else {
      this.appOutsideClick.emit(false);
    }
  }

}